<script setup lang="ts">
/**
 * **输出点行**：端口在右，标签靠右。
 *
 * 单独成文件的原因见 `verify:branches` —— 这一支和「变参行」长得像、位置又挨着，
 * 我在这两者之间连错过三次。拆开之后每个文件一眼能看完。
 */
import NpSocket from '../NpSocket.vue'
import type { OutputRow, SocketDef } from '../../types/node'
import type { SocketVisualState } from '../../node/socketState'

const props = defineProps<{
  row: OutputRow
  inGroup: boolean
  /** 端口视觉状态由宿主算好（组件不碰图引擎） */
  state: SocketVisualState
  def: SocketDef
}>()

const emit = defineEmits<{ (e: 'toggle-skip', value: boolean): void }>()
</script>

<template>
  <div
    class="np-row np-row--out"
    data-row-kind="output"
    :class="{ 'np-row--in-group': props.inGroup }"
  >
    <!--
      行级开关。**只有声明了 `skipEmpty` 的输出行才渲染** ——
      组件不知道「循环」是什么，是数据说了算。
    -->
    <button
      v-if="props.row.skipEmpty !== undefined"
      class="np-row__toggle nodrag"
      type="button"
      :class="{ 'is-on': props.row.skipEmpty }"
      :title="
        props.row.skipEmpty
          ? '这一路没值时跳过它（得到真实的 list；各 list 长度可能不同）'
          : '这一路没值时补一个空位（各 list 长度一致、能按行对应）'
      "
      @pointerdown.stop
      @click.stop="emit('toggle-skip', !props.row.skipEmpty)"
    >
      {{ props.row.skipEmpty ? '跳过空值' : '保留空位' }}
    </button>

    <span v-if="props.row.label" class="np-row__label np-row__label--end">
      {{ props.row.label }}
    </span>

    <!-- ⚠️ 必须转发：宿主靠它注入真实可拖拽的端口（不转发就「线连不上」） -->
    <slot name="socket-output" :def="props.def" :state="props.state" :row="props.row">
      <NpSocket side="output" :def="props.row.socket" :connected="!!props.row.socket.connected" />
    </slot>
  </div>
</template>
